// ==============================|| OVERRIDES - SELECT ||============================== //

export default function Select(theme) {
  return {
    MuiSelect: {
      styleOverrides: {
        root: {
          '& .MuiSelect-select': {
            paddingTop: '16px',
            paddingBottom: '16px',
            minHeight: '1.4375em'
          }
        },
        outlined: {
          '& .MuiSelect-select': {
            paddingTop: '16px',
            paddingBottom: '16px'
          }
        }
      }
    }
  };
} 